// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"ItemQualityFunctionality_sectionWrapper__xfaQs","radioButtonWrapper":"ItemQualityFunctionality_radioButtonWrapper__kpV6k"};